// extracted by mini-css-extract-plugin
module.exports = {"general-error":"_app_general-error__rDeNl","impersonating-banner":"_app_impersonating-banner__xMy7V","blinkingText":"_app_blinkingText__Pq0O9"};